export default "__VITE_ASSET__osUeuv7L__"